export default "assets/error-4ffedc6a.svg";